import { Form } from 'react-bootstrap';

/** Edit the same title draft in the table or an expanded place card. */
const PlaceTitleForm = ({ title, isClassic, onChange, onSave }) => (
  <Form
    className="min-w-0 w-100"
    onSubmit={(event) => {
      event.preventDefault();
      onSave();
    }}
  >
    <Form.Control
      aria-label="Place title"
      value={title}
      onChange={(event) => onChange(event.target.value)}
      className="w-100 rounded-2"
      style={isClassic ? { border: '1px solid currentColor' } : undefined}
    />
  </Form>
);

export default PlaceTitleForm;
